export default __webpack_public_path__ + "static/media/icon-menu.c599eed5.svg";